import { QI_FIELDS, type QiGroup } from '../manifest';

export const QI_EXPORT_GROUP_LABELS: Record<QiGroup, string> = {
  QIT: 'Optional home targets',
  PI: 'Pressure injuries',
  PR: 'Restrictive practices',
  UPWL: 'Unplanned weight loss',
  FMI: 'Falls and major injury',
  MM: 'Medication management',
  ADL: 'Activities of daily living',
  IAD: 'Incontinence care',
  HP: 'Hospitalisation',
  WF: 'Workforce',
  CEI: 'Consumer experience',
  QOL: 'Quality of life',
  AH: 'Allied health',
};
/** The GPMS field label is the format contract, including discipline and role wording. */
export function qiExportFieldLabel(code: string): string {
  return QI_FIELDS.find((field) => field.code === code)?.label ?? code;
}
